export enum SortSportEquipmentsColumnsEnum {
  CREATED_AT = "createdAt",
  NAME = "name",
  INVENTORY_NUMBER = "inventoryNumber",
  TECHNICAL_CONDITION = "technicalCondition",
  EQUIPMENT_TYPE = "equipment.equipmentType",
  COMMISSIONING_DATE = "commissioningDate",
  SPORT_ZONE = "sportZone",
  SPORT_SUBZONE = "sportSubZone"
}